import { trimmedStringFromUnknown } from "../protocol/shared.js";
import { openMeldRuntimeProfileIdSchema } from "../protocol/profile.js";
import { messageEnvelopeSchema } from "../protocol/message-envelope.js";
import { spaceThreadActionRefSchema } from "./space-thread.js";
import { spaceMessageFileReferencesSchema } from "../http/space-files.js";
                                        
import { spaceStatusSchema } from "./signal-status.js";
import * as z$1 from "zod/v4";
//#region src/schemas/space-mesh/openmeld-space-action.ts
const SPACE_UPDATES_DEFAULT_LIMIT = 20;
const SPACE_UPDATES_MAX_LIMIT = 200;
const signalIdRefSchema = z$1.strictObject({ signalId: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1)) });
const openMeldSpaceActionReplyToSchema = z$1.union([z$1.literal("current"), signalIdRefSchema]);
const openMeldSpaceActionReadUpdatesFromSchema = z$1.union([z$1.literal("last_public_reply"), signalIdRefSchema]);
const openMeldSpaceActionReadResultBySchema = z$1.union([z$1.strictObject({ resultRef: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1)) }), z$1.strictObject({ dispatchId: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1)) })]);
const openMeldSpacePostMessageActionSchema = z$1.strictObject({
	type: z$1.literal("post_message"),
	observedThroughSignalId: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1)).optional(),
	messageEnvelope: messageEnvelopeSchema,
	files: spaceMessageFileReferencesSchema.optional(),
	thread: spaceThreadActionRefSchema.optional(),
	saveResult: z$1.boolean().optional()
});
const openMeldSpacePostStatusActionSchema = z$1.strictObject({
	type: z$1.literal("post_status"),
	status: spaceStatusSchema,
	targetProfileId: openMeldRuntimeProfileIdSchema.optional(),
	text: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1).max(120)),
	replyTo: openMeldSpaceActionReplyToSchema.optional(),
	thread: spaceThreadActionRefSchema.optional(),
	saveResult: z$1.boolean().optional()
});
const openMeldSpaceStaySilentActionSchema = z$1.strictObject({
	type: z$1.literal("stay_silent"),
	reason: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1)),
	saveResult: z$1.boolean().optional()
});
const openMeldSpaceReadUpdatesActionSchema = z$1.strictObject({
	type: z$1.literal("read_updates"),
	from: openMeldSpaceActionReadUpdatesFromSchema,
	thread: spaceThreadActionRefSchema.optional(),
	limit: z$1.number().int().finite().positive().max(200).optional()
});
const openMeldSpaceReadResultActionSchema = z$1.strictObject({
	type: z$1.literal("read_result"),
	by: openMeldSpaceActionReadResultBySchema
});
const openMeldSpaceActionSchema = z$1.union([
	openMeldSpacePostMessageActionSchema,
	openMeldSpacePostStatusActionSchema,
	openMeldSpaceStaySilentActionSchema,
	openMeldSpaceReadUpdatesActionSchema,
	openMeldSpaceReadResultActionSchema
]);
const openMeldSpaceEgressActionSchema = z$1.union([
	openMeldSpacePostMessageActionSchema,
	openMeldSpacePostStatusActionSchema,
	openMeldSpaceStaySilentActionSchema
]);
//#endregion
export { SPACE_UPDATES_DEFAULT_LIMIT, SPACE_UPDATES_MAX_LIMIT, openMeldSpaceActionReadResultBySchema, openMeldSpaceActionReadUpdatesFromSchema, openMeldSpaceActionReplyToSchema, openMeldSpaceActionSchema, openMeldSpaceEgressActionSchema, openMeldSpacePostMessageActionSchema, openMeldSpacePostStatusActionSchema, openMeldSpaceReadResultActionSchema, openMeldSpaceReadUpdatesActionSchema, openMeldSpaceStaySilentActionSchema };

//# sourceMappingURL=openmeld-space-action.js.map